export default (metricsComponent) => ({
    smd_rowIdsArray: [],
    smd_pollingInterval: null,
    smd_dirtyManualMetrics: metricsComponent.dirtyManualMetrics,
    smd_editingKey: null,
    smd_clickStartElement: null,

    smd_manualCellHelpers: {
        manualCellsCount: 0,
        handleArrowKey: function(key, index, headersCount, cellPos) {
            let nextCell;
            let nextCellPos;
            switch (key) {
                case 'ArrowRight':
                    if(index === headersCount - 1) {
                        return;
                    }
                    nextCell = document.querySelector(`[data-pos='${cellPos + 1}']`);
                    break;
                case 'ArrowLeft':
                    if(index === 0) {
                        return;
                    }
                    nextCell = document.querySelector(`[data-pos='${cellPos - 1}']`);
                    break;
                case 'ArrowDown':
                    nextCellPos = cellPos + headersCount;

                    while(true) {
                        nextCell = document.querySelector(`[data-pos='${nextCellPos}']`);
                        if(nextCell) {
                            break; // Found it!
                        }

                        break; 
                    }

                    break;
                case 'ArrowUp':
                    nextCellPos = cellPos - headersCount;
                    if(nextCellPos < 0) {
                        return;
                    }

                    while(true) {
                        nextCell = document.querySelector(`[data-pos='${nextCellPos}']`);
                        if(nextCell) {
                            break;
                        }
                        break;
                    }
                    break;
            }
        
            if (nextCell && nextCell.offsetParent) {
                nextCell.focus();
                return true;
            } else if (key === 'ArrowDown' || key === 'ArrowUp') {
                // If next cell is not found, it might be off-screen.Will try to scroll the container.
                const currentCell = document.querySelector(`[data-pos='${cellPos}']`);
                if (currentCell) {
                    const container = currentCell.closest('[data-selector="scroll-container"]');
                    if (container) {
                        const rowHeight = 40; // Approximate row height
                        if (key === 'ArrowDown') {
                            container.scrollTop += rowHeight;
                        } else {
                            container.scrollTop -= rowHeight;
                        }
                    }
                }
            }
        },
    },

    smd_init() {        
        if(this.smd_dirtyManualMetrics && this.smd_dirtyManualMetrics.length > 0) {
          // Mark the exact stale metrics + their affected calculated metrics as loading
          for (const metricId of this.smd_dirtyManualMetrics) {
            this.smd_markMetricAndDependentsAsLoading(metricId)
          }
          this.smd_startPolling();
          this.updateFilteredSections();
        }
    },

    smd_startPolling() {
        if (this.smd_pollingInterval) {
          clearInterval(this.smd_pollingInterval)
        };
        
        window.dispatchEvent(new CustomEvent('sync-manual-started'));
        
        this.smd_pollingInterval = setInterval(() => {
             metricsComponent.call('processManualDataQueue').then(response => {
                 if (response === 'stop') {
                     clearInterval(this.smd_pollingInterval);
                     this.smd_pollingInterval = null;
                     window.dispatchEvent(new CustomEvent('sync-manual-refreshing'));
                     this.smd_refreshData();
                 } else if (response === 'queueing') {
                     window.dispatchEvent(new CustomEvent('sync-manual-queueing'));
                 } else if (response === 'processing') {
                     window.dispatchEvent(new CustomEvent('sync-manual-processing'));
                 }
             });
        }, 4000);
    },

    smd_markMetricAndDependentsAsLoading(metricId) {
        this.loadingMetrics[metricId] = true;
        for (const depId of this.getAffectedMetricIds(metricId)) {
            this.loadingMetrics[depId] = true;
        }
    },

    smd_refreshData() {
        metricsComponent.call('fetchData').then(data => {
            this.styleCache = {};
            this.deltaCache = {};
            this.fullScorecardData.metrics = data.metrics;
            this.updateMetas();
            this.loadingMetrics = {};
            this.updateFilteredSections();
            window.dispatchEvent(new CustomEvent('sync-manual-stopped'));
        }).catch(error => {
            console.error('Failed to refresh scorecard data:', error);
            this.loadingMetrics = {};
            this.updateFilteredSections();
            window.dispatchEvent(new CustomEvent('sync-manual-stopped'));
        });
    },

    isCellFetching(row, headerData) {
        const metric = this.fullScorecardData?.metrics?.[row.metric_id];
        const data = metric?.data?.[this.manualEntryInterval]?.[headerData.start_date];
        return data?.is_fetching === true;
    },

    getAffectedMetricIds(metricId) {
        const metrics = this.fullScorecardData?.metrics;
        if (!metrics) return [];

        // Build inverse dependency map: ingredient ID → [calculated metric IDs that use it]
        const dependentsMap = {};
        for (const [id, metric] of Object.entries(metrics)) {
            const ingredients = metric.associated_calculated_metrics || [];
            for (const ingredient of ingredients) {
                const ingredientId = ingredient.id ?? ingredient;
                if (!dependentsMap[ingredientId]) dependentsMap[ingredientId] = [];
                dependentsMap[ingredientId].push(Number(id));
            }
        }

        // Walk transitively from the given metric
        const affected = [];
        const queue = [Number(metricId)];
        const visited = new Set();

        while (queue.length > 0) {
            const current = queue.shift();
            const dependents = dependentsMap[current] || [];
            for (const dep of dependents) {
                if (!visited.has(dep)) {
                    visited.add(dep);
                    affected.push(dep);
                    queue.push(dep);
                }
            }
        }

        return affected;
    },

    // UI Methods
    smd_isEditing(rowId, headerIdx) {
        return this.smd_editingKey === `${rowId}-${headerIdx}`;
    },

    smd_setEditing(rowId, headerIdx) {
        this.smd_editingKey = `${rowId}-${headerIdx}`;
        this.$nextTick(() => {
            const cell = document.querySelector(`[data-cell-id='${rowId}-${headerIdx}']`);
            if (!cell) return;

            const container = cell.closest('[data-selector="scroll-container"]');
            
            if (!container) {
                cell.scrollIntoView({ block: 'nearest', inline: 'nearest' });
                return;
            }

            const cellRect = cell.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            
            let stickyWidth = 0;
            // Find the row that contains this cell and has a sticky cell
            let row = cell.parentElement;
            while (row && row !== container) {
                const stickyCell = row.querySelector('[data-selector="sticky-cell"]');
                if (stickyCell) {
                    stickyWidth = stickyCell.getBoundingClientRect().width;
                    break;
                }
                row = row.parentElement;
            }

            const stickyEdge = containerRect.left + stickyWidth;
            
            if (cellRect.left < stickyEdge) {
                container.scrollLeft -= (stickyEdge - cellRect.left) + 20;
            } else if (cellRect.right > containerRect.right) {
                container.scrollLeft += (cellRect.right - containerRect.right) + 20;
            }

            if (cellRect.top < containerRect.top) {
                container.scrollTop -= (containerRect.top - cellRect.top) + 20;
            } else if (cellRect.bottom > containerRect.bottom) {
                container.scrollTop += (cellRect.bottom - containerRect.bottom) + 20;
            }
        });
    },

    smd_focusInput(rowId, headerIdx) {
        this.$nextTick(() => {
            const input = document.getElementById(`manual-input-${rowId}-${headerIdx}`);
            if (input) input.focus();
        });
    },

    smd_handleCellKeyDown(e, rowId, headerIdx, pos, headersCount, row, headerData) {
        const key = e.code;
        const isInput = e.target.tagName.toUpperCase() === 'INPUT';
        if (isInput) return;

        if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(key)) {
            e.preventDefault();
            this.smd_manualCellHelpers.handleArrowKey(key, headerIdx, headersCount, pos);
            return;
        }

        if (key === 'Backspace' || key === 'Delete') {
            e.preventDefault();
            const input = document.getElementById(`manual-input-${rowId}-${headerIdx}`);
            let oldValue = '';
            if (input) {
                oldValue = input.value;
                input.value = '';
                input.dispatchEvent(new Event('input'));
            }
            this.smd_saveValue("", oldValue, row, headerData, headerIdx);
            return;
        }

        if (key === 'Enter' || key === 'Space') {
            e.preventDefault();
            this.smd_setEditing(rowId, headerIdx)
            this.smd_focusInput(rowId, headerIdx);
            return;
        }

        // Excel style editing on typing
        const isNumber = (e.key >= '0' && e.key <= '9') || key.startsWith('Numpad') || e.key === '-' || e.key === '.';

        if (isNumber && e.key.length === 1) {
            this.smd_setEditing(rowId, headerIdx)
            this.smd_focusInput(rowId, headerIdx);
            
            this.$nextTick(() => {
                 const input = document.getElementById(`manual-input-${rowId}-${headerIdx}`);
                 if(input) {
                     input.value = e.key;
                     input.dispatchEvent(new Event('input'));
                 }
            });
        } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
             // Handle other characters (like backspace or letters if needed, though input is type=number)
             // For type=number, letters might not work, but we should still focus.
             // If the user types a non-number, we might just want to focus the input.
             this.smd_setEditing(rowId, headerIdx)
             this.smd_focusInput(rowId, headerIdx);
        }
    },

    smd_handleInputKeyDown(e, rowId, headerIdx) {
        if (e.code === 'Enter') {
            const cell = document.querySelector(`[data-cell-id='${rowId}-${headerIdx}']`);
            if (cell) cell.focus();
        }
        if (e.code === 'Escape') {
            const cell = document.querySelector(`[data-cell-id='${rowId}-${headerIdx}']`);
            if (cell) cell.focus();
        }
    },

    smd_handlePaste(e, rowId, headerIdx, row, headerData) {
        if (e.target.tagName.toUpperCase() === 'INPUT') return;

        e.preventDefault();
        const pastedData = (e.clipboardData || window.clipboardData).getData('text');
        const newValue = pastedData.trim();
        const input = document.getElementById(`manual-input-${rowId}-${headerIdx}`);
        let oldValue = '';
        if (input) {
            oldValue = input.value;
            input.value = newValue;
            input.dispatchEvent(new Event('input'));
        }

        this.smd_saveValue(newValue, oldValue, row, headerData, headerIdx);
    },

    smd_saveValue(value, oldValue, row, headerData, headerIdx) {
        const newValue = value === "" ? null : +value;
      
        if (newValue === oldValue) return;
        if (newValue === null && oldValue === "") return;

        // Update local state
        const metric = this.fullScorecardData.metrics[row.metric_id];
        if (metric && metric.data && metric.data[this.manualEntryInterval]) {
             if (!metric.data[this.manualEntryInterval][headerData.start_date]) {
                 metric.data[this.manualEntryInterval][headerData.start_date] = {};
             }
             const cellData = metric.data[this.manualEntryInterval][headerData.start_date];
             cellData.raw_value = newValue;
             cellData.formatted_value = '...';
             cellData.is_fetching = true;
        } else {
            console.warn('Cell not found!'); 
        }

        // Mark the edited metric and all transitively affected calculated metrics as loading (view mode only)
        this.smd_markMetricAndDependentsAsLoading(row.metric_id)

        // Send to backend. A cleared cell (newValue === null) rides the same queue/save path and is
        // stored in BigQuery as NULL — there is no longer a separate delete call. queueManualData
        // returns '' for a cleared cell, so the unified handler below blanks it correctly.
        metricsComponent.call('queueManualData', {
            metric_id: row.metric_id,
            row_id: row.id,
            value: newValue,
            old_value: oldValue,
            start_date: headerData.start_date,
            end_date: headerData.end_date,
            cell_index: `metric-${row.id}-cell-${headerIdx}-${this.manualEntryInterval}`
        }).then(formattedValue => {
             // Update local state with formatted value and remove fetching cell state
             const metric = this.fullScorecardData.metrics[row.metric_id];
             if (metric && metric.data && metric.data[this.manualEntryInterval]) {
                 const cellData = metric.data[this.manualEntryInterval][headerData.start_date];
                 if (cellData) {
                     cellData.formatted_value = formattedValue;
                     cellData.no_seperators_or_labels_formatted_value = newValue;
                     cellData.is_fetching = false;
                 }
             }

             if (this.styleCache) {
                 delete this.styleCache[`${row.metric_id}-${headerData.start_date}`];
             }
             this.clearDeltaCacheForMetric(row.metric_id);
        });

        this.smd_startPolling();
    }
})
